import permissions from '@/constants/permissions'

const PublishChild = () => import('@/views/PublishChild.vue')

export default {
  path: '/publikacja-dziecka/:childEditionId',
  name: 'Publish',
  component: PublishChild,
  meta: {
    requireAuth: true,
    permission: permissions.childEditionPublish
  }
}
